<script>
import Layout from '@layouts/public.vue'
import BaseButton from '@components/_base-button.vue'

export default {
  metaInfo: {
    title: 'Page Not Found 404',
    meta: [{ name: 'description', content: '404' }],
  },
  components: { Layout, BaseButton },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <Layout>
    <div class="text-center">
      <h1 class="display-4 font-weight-bold white--text mt-0 mb-2">404</h1>
      <h3 class="display-1 white--text">
        <template v-if="resource"> {{ resource }} </template>
        Not Found
      </h3>

      <v-flex>
        <BaseButton class="mt-8" depressed light color="white" to="/">
          Home Page
        </BaseButton>

        <!-- TODO: Add logout button with conditional if authenticated -->
      </v-flex>
    </div>
  </Layout>
</template>
